import { Component, Input, OnInit } from '@angular/core';
import { CellData, ComponentData, TableData } from '@ddt-web/data-service';
import { BrowserVersionUtil } from '@ddt-web/generic-utils';
import * as get from 'lodash/get';
import * as set from 'lodash/set';

@Component({
	selector: 'perf-benchmark-comparison',
	templateUrl: './benchmark-comparison.component.html',
	styleUrls: ['./benchmark-comparison.component.scss']
})
export class BenchmarkComparisonComponent implements OnInit {
	@Input() public data: ComponentData;
	@Input() public columnsAlwaysToShow: string[];

	public benchmarkComparisonTableData: TableData;
	public dataArray: Array<{ [key: string]: CellData }>;
	public infoBubbleMappings: { [key: string]: string } = {};
	public isIE: boolean = false;

	public ngOnInit(): void {
		if (this.data.success) {
			this.benchmarkComparisonTableData = get(this.data, `tab['benchmark-comparison'].tableData[0]`);
			this.dataArray = this.getDataArray();
			this.infoBubbleMappings = this.createColumnMappings();
		}
		this.isIE = BrowserVersionUtil.isBrowserIEorEdge();
	}

	/**
	 * Parses the table data and returns a data array with column heading keys and the content.
	 */
	public getDataArray(): Array<{ [key: string]: CellData }> {
		const mappedDataArray = [];
		if (this.benchmarkComparisonTableData && this.benchmarkComparisonTableData.cells) {
			this.benchmarkComparisonTableData.cells.forEach(cellData => {

				// Add url attribute to description cells
				const product = cellData.find(cell => cell.config.id === 'portfolioId');
				const description = cellData.find(cell => cell.config.id === 'description');

				if (product && product.rawValue && description) {
					set(description, 'attribute.url', product.rawValue);
				}

				const cellRow = {};
				cellData.forEach(cell => {
					if (cell.config.visible) {
						cellRow[cell.config.label.defaultText] = cell;
					}
				});
				mappedDataArray.push(cellRow);
			});
		}
		return mappedDataArray;
	}

	/**
	 * Parses the table data and saves information bubble mappings as an array in this.infoBubbleMappings.
	 */
	public createColumnMappings(): { [key: string]: string } {
		const infoBubbleMappings = {};
		if (this.benchmarkComparisonTableData && this.benchmarkComparisonTableData.cells && this.benchmarkComparisonTableData.headersX) {
			this.benchmarkComparisonTableData.cells[0]
				.filter((cell: CellData) => cell.config.visible)
				.forEach((cell: CellData) => {
					const header = this.benchmarkComparisonTableData.headersX.find(header => header.config.id === cell.config.id);
					infoBubbleMappings[cell.config.label.defaultText] = header ? header.attribute.infoBubble : null;
				});
		}
		return infoBubbleMappings;
	}
}
